"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DROPFILTER : DROPDOWN ITEM : STYLES --------------- ++++++++++ */


var _default = {
  dropdownitem: {
    display: 'flex',
    alignItems: 'center',
    padding: (0, _index.replacePXinStringWithEM)('7px 0'),
    // height: pxToEm(16),
    fontSize: (0, _index.pxToEm)(14),
    fontWeight: '500',
    color: _index.theme.color.supporting.medium.swatch,
    background: _index.theme.color.light.light.swatch,
    cursor: 'pointer',
    transition: 'all .15s',
    position: 'relative',
    '& .dropdownitemtext': {
      // maxWidth: '20ch',
      flex: '1',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '&:hover': {
      color: _index.theme.color.primary.medium.swatch
    },
    '& .name-check': {
      height: (0, _index.pxToEm)(24),
      width: (0, _index.pxToEm)(24),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: (0, _index.pxToEm)(4),
      fontSize: (0, _index.pxToEm)(16),
      fontWeight: '900',
      marginRight: (0, _index.pxToEm)(10)
    },
    '&.active-true': {
      color: _index.theme.color.primary.medium.swatch,
      '& .name-check': {
        color: _index.theme.color.light.light.swatch,
        background: _index.theme.color.primary.medium.swatch
      }
    },
    '&.active-false': {
      '& .name-check': {
        color: _index.theme.color.supporting.light.swatch,
        background: _index.theme.color.supporting.light.swatch,
        border: "".concat((0, _index.pxToEm)(2), " solid #EEF2F6")
      }
    },
    '& .highlight': {
      fontWeight: '600',
      background: _index.theme.color.primary.light.swatch
    },
    '& input[type="text"]': {
      font: 'inherit'
    },
    '& .dropdowniteminput': {
      flex: 1,
      minWidth: 0,
      border: 'none',
      borderBottom: '1px solid',
      borderBottomColor: 'rgb(20, 148, 244)',
      marginTop: (0, _index.pxToEmWithBaseline)({
        value: 2,
        fontSizeBaseline: 14
      }),
      color: _index.theme.color.supporting.medium.swatch,
      background: _index.theme.color.light.light.swatch,
      '&:focus': {
        outline: 'none'
      },
      '&.valid-false': {
        background: _index.theme.color.attention.medium.swatch,
        transition: 'background-color 0.5s ease'
      },
      '&.valid-true': {
        // background: theme.color.attention.medium.swatch,
        transition: 'background-color 0.5s ease-out'
      }
    }
  }
};
exports.default = _default;